import {sanitizeObject} from "../helpers/sanitizers";
import {renameProperty} from "../helpers/rename-object-property";

export default (appointmentDetails) => {
    const parsedResponse = renameProperty(appointmentDetails, "appointmentGeoData", "appointment_geo_data");
    return sanitizeObject(parsedResponse);
};
